// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion/Accordion";
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import Minus, { MinusOffset } from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins/icon";
import { css } from "styled-components";

const borderWidth = "1px";
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        padding: ${pxToRem(16, 0)};
        background-color: ${getColor("common.background")};
        border: none;
        border-top: ${borderCss};
        border-bottom: ${borderCss};
        color: inherit;
        transition: ${transitionHoverStyles("color")};

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            font-size: ${theme.design.typography.size.base};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &:hover {
            color: ${getColor("primary.main")};
        }

        ${breakpoint("lg")} {
            font-size: ${x => x.theme.design.typography.size.large};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionProductDetailsSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }

            ${AccordionStyle} + ${AccordionStyle} && {
                &:first-of-type button {
                    margin-top: -${borderWidth};
                }
            }
        `,
    },
    panelProps: {
        css: css`
            ${({ theme }) => css`
                ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                ${breakpointValues(theme.design.accordion.padding.vertical, "padding-top")}
            `}
            background-color: ${getColor("common.background")};
            border: ${borderCss};
            border: none;

            &:last-of-type {
                border-bottom: ${borderCss};
            }
        `,
    },
    expandIconProps: {
        src: Plus,
        color: "inherit",
        css: css`
            ${iconScalableStyles("1.2em", PlusOffset)}
            margin-left: 1em;
        `,
    },
    collapseIconProps: {
        src: Minus,
        color: "inherit",
        css: css`
            ${iconScalableStyles("1.2em", MinusOffset)}
            margin-left: 1em;
        `,
    },
};
